import { render } from "./vue-resizable.vue?vue&type=template&id=3de5149f&scoped=true"
import script from "./vue-resizable.vue?vue&type=script&lang=js"
export * from "./vue-resizable.vue?vue&type=script&lang=js"

import "./vue-resizable.vue?vue&type=style&index=0&id=3de5149f&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\resizable2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de5149f"]])

export default __exports__